import { LABELS } from '@/constants/common/message.constants'

import { type DispatchListExEntity } from '../../aspida/@types'

/**
 * パートナー種別
 */
export type PartnerTier = DispatchListExEntity['partnerTier']

export const PARTNER_TIER = {
  /** 自社パートナー */
  ZERO_PARTNER_IN_HOUSE: 'ZERO_PARTNER_IN_HOUSE',
  /** 契約業者パートナー */
  ONE_PARTNER_CONTRACTOR: 'ONE_PARTNER_CONTRACTOR',
  /** 2次請けパートナー */
  TWO_SUB_PARTNER: 'TWO_SUB_PARTNER',
  /** 3次請けパートナー */
  THREE_SUB_PARTNER: 'THREE_SUB_PARTNER',
  /** 4次請けパートナー */
  FOUR_SUB_PARTNER: 'FOUR_SUB_PARTNER',
  /** 5次請けパートナー */
  FIVE_SUB_PARTNER: 'FIVE_SUB_PARTNER',
  /** 6次請けパートナー */
  SIX_SUB_PARTNER: 'SIX_SUB_PARTNER',
  /** 7次請けパートナー */
  SEVEN_SUB_PARTNER: 'SEVEN_SUB_PARTNER',
  /** 8次請けパートナー */
  EIGHT_SUB_PARTNER: 'EIGHT_SUB_PARTNER',
  /** 9次請けパートナー */
  NINE_SUB_PARTNER: 'NINE_SUB_PARTNER'
} as const satisfies Record<PartnerTier, PartnerTier>

export const PARTNER_TIER_LABEL = {
  [PARTNER_TIER.ZERO_PARTNER_IN_HOUSE]: LABELS.EMPTY,
  [PARTNER_TIER.ONE_PARTNER_CONTRACTOR]: LABELS.ONE_PARTNER_CONTRACTOR,
  [PARTNER_TIER.TWO_SUB_PARTNER]: LABELS.TWO_SUB_PARTNER,
  [PARTNER_TIER.THREE_SUB_PARTNER]: LABELS.THREE_SUB_PARTNER,
  [PARTNER_TIER.FOUR_SUB_PARTNER]: LABELS.FOUR_SUB_PARTNER,
  [PARTNER_TIER.FIVE_SUB_PARTNER]: LABELS.FIVE_SUB_PARTNER,
  [PARTNER_TIER.SIX_SUB_PARTNER]: LABELS.SIX_SUB_PARTNER,
  [PARTNER_TIER.SEVEN_SUB_PARTNER]: LABELS.SEVEN_SUB_PARTNER,
  [PARTNER_TIER.EIGHT_SUB_PARTNER]: LABELS.EIGHT_SUB_PARTNER,
  [PARTNER_TIER.NINE_SUB_PARTNER]: LABELS.NINE_SUB_PARTNER
} as const satisfies Record<PartnerTier, string>
